import { render, staticRenderFns } from "./dianyingHome.vue?vue&type=template&id=4fb04ecf&scoped=true"
import script from "./dianyingHome.vue?vue&type=script&lang=js"
export * from "./dianyingHome.vue?vue&type=script&lang=js"
import style0 from "./dianyingHome.vue?vue&type=style&index=0&id=4fb04ecf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../youyidian_pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb04ecf",
  null
  
)

export default component.exports